// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"663":"0f84e852","782":"3edd36a6"}[chunkId] + ".chunk.css";
};